import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import apiPath from "../../utils/apiPath";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";
import OButton from "components/reusable/OButton";
import useToastContext from "hooks/useToastContext";
import { apiGet, apiPost } from "../../utils/apiFetch";
import { FiDownload } from "react-icons/fi";
// PREVIOUS download used helpers.downloadFile. Uncomment with the old handler.
// import helpers from "../../utils/helpers";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { sortingOptionsOfferTable } from "utils/constants";

const FinalOfferTable = ({ allOfferList, offerList, page, sort, setSort, handleView }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const sendOfferLetter = async (item) => {
    try {
      const payload = {
        fullName: item?.Employee?.name,
        companyName: item?.Company?.name,
        designation: item?.JobDepartment?.name,
        dateofJoining: item?.acceptedRejectedAt,
        employeeID: item?.Employee?._id,
        jobRequestID: item?._id,
        duration: item?.duration,
        employeeEmail: item?.Employee?.email,
      };
      const path = apiPath.sendOffer;
      const result = await apiPost(path, payload);
      if (result?.status === 200) {
        allOfferList();
        notification.success(result?.data?.message);
      }
    } catch (error) {
      console.log("error in send offer ==>>>>", error.message);
    }
  };
  // PREVIOUS: download called POST /send-offer-letter. That API also emailed
  // the letter and returned a public S3 URL. The bucket is private, so the
  // browser saved AccessDenied XML as offer-letter<timestamp>.pdf and the
  // file failed to open.
  // const handleDownloadSample = async (item) => {
  //   try {
  //     const payload = {
  //       fullName: item?.Employee?.name,
  //       companyName: item?.Company?.name,
  //       designation: item?.JobDepartment?.name,
  //       dateofJoining: item?.acceptedRejectedAt,
  //       employeeID: item?.Employee?._id,
  //       jobRequestID: item?._id,
  //       duration: item?.duration,
  //       employeeEmail: item?.Employee?.email,
  //     };
  //     const path = apiPath.sendOffer;
  //     const result = await apiPost(path, payload);
  //     if (result.data.success) {
  //       helpers.downloadFile(result?.data?.results?.file_path);
  //     }
  //   } catch (error) {
  //     console.log("error:", error);
  //   }
  // };
  const handleDownloadSample = async (item) => {
    try {
      const path = `${apiPath.downloadoffer}/${item?._id}`;
      const result = await apiGet(path, {}, { responseType: "blob" });
      const blob = result?.data;
      const contentType = String(result?.headers?.["content-type"] || blob?.type || "");
      if (!blob || contentType.includes("application/json") || contentType.includes("xml")) {
        notification.error("Unable to open the offer letter PDF.");
        return;
      }
      const headerName = String(result?.headers?.["content-disposition"] || "");
      const headerFile = headerName.match(/filename="([^"]+)"/);
      const fileName =
        headerFile?.[1] ||
        item?.offerLetterFileName ||
        `offer-letter-${item?.Employee?.employeeId || "download"}.pdf`;
      const fileURL = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
    } catch (error) {
      console.log("error:", error);
      notification.error("Unable to open the offer letter PDF.");
    }
  };
  const handleSortTable = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };
  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("JOB_TITLE")} />
                <TableHeaderCell text={t("DEPARTMENT")} />
                <TableHeaderCell text={t("YEAR_OF_EXPERIENCE")} />
                {sortingOptionsOfferTable?.map((option) => (
                  <th key={option.sortBy} scope="col" className="cursor-pointer py-3 px-6 " onClick={() => handleSortTable(option.sortBy, "asc")}>
                    <div className="flex justify-start">
                      <span>{option.displayText}</span>
                      <span>
                        {sort.sortType === "asc" && sort.sortBy === option.sortBy && <BsArrowUpShort className="w-4 h-4" />}
                        {sort.sortBy === option.sortBy && sort.sortType === "desc" && <BsArrowUpShort className="rotate-180 w-4 h-4 " />}
                      </span>
                    </div>
                  </th>
                ))}
                <th scope="col" className="py-3 px-6 text-center">
                  {t("OFFER_LETTER_STATUS")}
                </th>
                <th scope="col" className="py-3 px-6 text-center  ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {offerList &&
                offerList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="border-r py-4 px-4 text-gray-900">
                        {item?.employmentStatus === "terminated"
                          ? `${item?.Company?.name?.substring(0, 3) || ""}${item?.Employee?._id?.toString().slice(-3) || ""}`
                          : item?.Employee?.employeeId}
                      </td>
                      {/* <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.employeeId}</td> */}
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Job?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.JobDepartment?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.yearOfExperiece}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.email}</td>

                      <td className="py-4 px-6 border-r text-left text-gray-900">{item?.offerSentDate ? dayjs(item?.offerSentDate).format("MM-DD-YYYY h:mm A") : "N/A"} </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        <>
                          {startCase(item?.offerLetterStatus)}
                          {item?.offerLetterStatus == "sent" ? (
                            <a
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                handleDownloadSample(item);
                              }}
                            >
                              <FiDownload className="mr-3" />
                            </a>
                          ) : (
                            ""
                          )}
                        </>
                      </td>

                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center">
                            <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="View employee list">
                                {" "}
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                              </a>
                            </li>
                            {item?.offerLetterStatus != "sent" && <OButton label="Send Offer" type="button" onClick={() => sendOfferLetter(item)} extraClasses="ml-3 mb-3" style={{ borderRadius: "0.5rem" }} />}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(offerList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={10}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinalOfferTable;
